module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sshet-basic-details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "shadow clearfix"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Details"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-bd-property"
    }
  }, [_vm._v("Property")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.property),
      expression: "entity.property"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sd-bd-property"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "property", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.properties), function(opt) {
    return _c('option', {
      domProps: {
        "value": opt
      }
    }, [_vm._v(_vm._s(opt))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-data-type"
    }
  }, [_vm._v("Data Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.dataType),
      expression: "entity.dataType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sd-data-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "dataType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('SPREADSHEET_DATA_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActualValue),
      expression: "isActualValue"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-actual"
    }
  }, [_vm._v("Actual Value")]), _vm._v(" "), (_vm.useDropdownActualValue) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.actualValue),
      expression: "entity.actualValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sd-actual"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "actualValue", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.actualValueOptions), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.code
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.actualValue),
      expression: "entity.actualValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-actual"
    },
    domProps: {
      "value": (_vm.entity.actualValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "actualValue", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isActualValue),
      expression: "!isActualValue"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-tab"
    }
  }, [_vm._v("Tab Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.tabName),
      expression: "entity.tabName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-tab"
    },
    domProps: {
      "value": (_vm.entity.tabName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "tabName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMainSpreadsheetField),
      expression: "isMainSpreadsheetField"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-nm"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-nm"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isActualValue),
      expression: "!isActualValue"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-cell"
    }
  }, [_vm._v("Cell")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.cell),
      expression: "entity.cell"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-cell"
    },
    domProps: {
      "value": (_vm.entity.cell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "cell", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMainSpreadsheetField),
      expression: "isMainSpreadsheetField"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-sr"
    }
  }, [_vm._v("Start Row")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.startRow),
      expression: "entity.startRow"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-sr"
    },
    domProps: {
      "value": (_vm.entity.startRow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "startRow", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-er"
    }
  }, [_vm._v("End Row")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.endRow),
      expression: "entity.endRow"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-er"
    },
    domProps: {
      "value": (_vm.entity.endRow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "endRow", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-s-column"
    }
  }, [_vm._v("Start Column")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.startColumn),
      expression: "entity.startColumn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-s-column"
    },
    domProps: {
      "value": (_vm.entity.startColumn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "startColumn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-e-column"
    }
  }, [_vm._v("End Column")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.endColumn),
      expression: "entity.endColumn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-e-column"
    },
    domProps: {
      "value": (_vm.entity.endColumn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "endColumn", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.saveOrUpdate) + "\n            ")]), _vm._v(" "), (_vm.entity.id) ? _c('div', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.doClear
    }
  }, [_vm._v("\n              Add\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('vue-table', {
    attrs: {
      "tableData": _vm.details,
      "tableTitle": "Details",
      "showEdit": true,
      "showDelete": true,
      "fields": _vm.fields
    },
    on: {
      "table-edit-request": _vm.updateActive,
      "table-delete-request": _vm.doDelete
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1027e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/SpreadsheetDescriptor/BasicDetails.vue
// module id = 2155
// module chunks = 1